<template>
    <div class="dashboard">
        <div class="mx-0 px-0">
            <div class="row flex-column flex-lg-row mx-0 px-0">
                <!-- Left Column -->
                <div class="col-12 col-md-12 col-xl-8 left-column mb-4 mb-lg-0 mx-0 pl-0 pr-md-2 pr-0">
                    <h1 class="main-title mx-0 px-0 mb-md-0 mb-4">
                        Inventario de Productos Químicos <span class="text-primary">(PQ)</span>
                    </h1>

                    <div class="row stats-row mx-0 px-0">
                        <div class="col-12 col-md-4 mx-0 px-0">
                            <StatsCard :value="dataDash1.total_inventory" title="Total RPQ " />
                        </div>
                        <div class="col-12 col-md-4 mx-0 px-0">
                            <StatsCard :value="fdsWithReview" title="Mercancías peligrosas" />
                        </div>
                        <div class="col-12 col-md-4 px-0">
                            <StatsCard :value="productNotDangerCount" title="Sin afectaciones para la salud" />
                        </div>
                    </div>

                    <div class="tree-section mx-0 px-0 pr-md-2 pr-0">
                        <div class="row equal-height">
                            <div class="col-12 col-md-6 mb-4 mb-md-0">
                                <div class="h-100">

                                    <LegislationChart :data="{
                                        characterized: dataDash1.total_inventory_verified_cumply || 0,
                                        nonCompliant: dataDash1.not_comply || 0,
                                        noDocument: dataDash1.not_document || 0,
                                        fdsWithReviewed: (dataDash1.total_inventory_verified_cumply - dataDash1.attachment_not_revision) || 0,
                                        fdsNotReviewed: dataDash1.attachment_not_revision || 0,
                                        notCaracterizedWithCumply: dataDash1.total_inventory_for_verification_cumply || 0,
                                    }" />
                                </div>
                            </div>
                            <div class="col-12 d-block d-md-none">
                                <IconList :items="items" />
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column h-100 secondary-chart">
                                    <ChartCard title="Estatus Productos Caracterizados"
                                        @chart-info-click="handleChartInfo" :showInfoButton="false"
                                        chartKey="acute_toxicity_mortal" :options="statusInventoryChartOptions"
                                        :isLoading="isLoadingChartInfo['acute_toxicity_mortal']" />
                                    <div class="d-none d-md-block">
                                        <IconList :items="items" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column - Scrollable -->
                <div class="col-12 col-md-12 col-xl-4 right-column px-0 mx-0">
                    <div class="scrollable-content px-0 mx-0">
                        <div class="charts-container px-0 mx-0">
                            <div class="row px-0 mx-0">
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-md-0 px-0 px-md-2">
                                    <ChartCard title="PQ Caracterizados - Actualizaciones"
                                        @chart-info-click="handleChartInfo" :showInfoButton="false"
                                        chartKey="carcinogenicity" :options="benefitForYearsChartOptions"
                                        :isLoading="isLoadingChartInfo['carcinogenicity']" />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-4 px-0 pl-md-1">
                                    <ChartCard title="Peligrosidad del Inventario" @chart-info-click="handleChartInfo"
                                        :showInfoButton="false" chartKey="carcinogenicity"
                                        :options="riskInventoryChartOptions"
                                        :isLoading="isLoadingChartInfo['carcinogenicity']" />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Disponibilidad en inventario" @chart-info-click="handleChartInfo"
                                        :showInfoButton="false" chartKey="carcinogenicity"
                                        :options="useandDesuseChartOptions"
                                        :isLoading="isLoadingChartInfo['carcinogenicity']" />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-md-0 px-0 px-md-2">
                                    <ChartCard title="Sujetos a regulación" @chart-info-click="handleChartInfo"
                                        :showInfoButton="false" chartKey="carcinogenicity"
                                        :options="optionsBarsSuggestionRegulation"
                                        :isLoading="isLoadingChartInfo['carcinogenicity']" />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-md-0 px-0 px-md-2">
                                    <ChartCard title="Analisis de riesgos" @chart-info-click="handleChartInfo"
                                        :showInfoButton="false" chartKey="priority" :options="riskAnalysisChartOptions"
                                        :isLoading="isLoadingChartInfo['priority']" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ProductListModal :modal-id="'products-modal'" :title="modalTitle" :products="selectedProducts" />
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ChartCard from '../components/health/ChartCard.vue';
import IndicatorCard from '../components/health/IndicatorCard.vue';
import StatsCard from '../components/health/StatsCard.vue';
import CenterBody from '../components/health/CenterBody.vue';
import ProductListModal from '../components/ProductListModal.vue';
import LegislationChart from '../components/general/LegislationChart.vue';
import IconList from '../components/general/IconList.vue';
import {
    getCategoryChartOptions,
    getCarcinogenicityChartOptions,
    getPriorityChartOptions,
    productsChartOptions,
    healthEffectsChartOptions,
    sensitizersChartOptions,
    getReprotoxicityChartOptions,
    getOtoxicityChartOptions,
    getMutagenicityChartOptions,
    getHealthCategoriesChartOptions,
    getNeurotoxicChartOptions,
    getCorrosiveChartOptions,
    getSensitizingChartOptions,
    getStatusInventoryPQChartOptions,
    getRiskInventoryChartOptions,
    getUseandDesuseChartOptions,
    getOptionsBarsSuggestionRegulation,
    getBenefitForYearsChartOptions,
    getRiskAnalysisChartOptions
} from '../config/chartOptions';

export default {
    name: 'Health',
    components: {
        ChartCard,
        IndicatorCard,
        StatsCard,
        CenterBody,
        ProductListModal,
        LegislationChart,
        IconList,
    },
    data() {
        return {
            priorityCurrentPage: 1,
            productsChartOptions,
            healthEffectsChartOptions,
            sensitizersChartOptions,
            modalTitle: '',
            selectedProducts: [],
            chartInfoButtons: {
                acute_toxicity_mortal: true,
                carcinogenicity: true,
                components_priority_normative: false,
                reprotoxicity: true,
                otoxicity: true,
                neurotoxic: true,
                corrosive: true,
                mutagenicity: true,
                sensitizing: true,
                products_by_location: false
            },
            isLoadingChartInfo: {}
        };
    },
    computed: {
        ...mapState("dashboard", ["dataDash1", "dataDash2", "dashboardFilters", "productsDashAffected"]),
        categoryChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCategoryChartOptions(this.dataDash2);
        },
        carcinogenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCarcinogenicityChartOptions(this.dataDash2);
        },
        priorityFullData() {
            return (this.dataDash2 && this.dataDash2.components_priority_normative) || [];
        },
        priorityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getPriorityChartOptions(this.dataDash2, this.priorityCurrentPage, 10);
        },
        reprotoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getReprotoxicityChartOptions(this.dataDash2);
        },
        otoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getOtoxicityChartOptions(this.dataDash2);
        },
        mutagenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getMutagenicityChartOptions(this.dataDash2);
        },
        healthCategoriesChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getHealthCategoriesChartOptions(this.dataDash2);
        },
        neurotoxicChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getNeurotoxicChartOptions(this.dataDash2);
        },
        corrosiveChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCorrosiveChartOptions(this.dataDash2);
        },
        sensitizingChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getSensitizingChartOptions(this.dataDash2);
        },
        fdsWithReview() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return 0;
            return this.dataDash1.attachment_with_revision;
        },
        productNotDangerCount() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return 0;
            return this.dataDash2.product_not_danger_count;
        },
        items() {
            return [
                {
                    icon: 'FdsIcon',
                    number: this.dataDash1.fds_not_spain || 0,
                    text: 'FDS Otros Idiomas'
                },
                {
                    icon: 'MsdsIcon',
                    number: this.dataDash1.msds || 0,
                    text: 'No. de MSDS'
                },
                {
                    icon: 'TanquesIcon',
                    number: this.dataDash1.total_tanks ||0,
                    text: 'Tanques'

                },
                {
                    icon: 'InstalacionesIcon',
                    number: this.dataDash1.classified_facilities || 0,
                     text: 'Instalaciones Clasificadas'

                }
            ];
        },
        statusInventoryChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getStatusInventoryPQChartOptions(this.dataDash1);
        },
        riskInventoryChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getRiskInventoryChartOptions(this.dataDash1);
        },
        useandDesuseChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getUseandDesuseChartOptions(this.dataDash1);
        },
        optionsBarsSuggestionRegulation() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getOptionsBarsSuggestionRegulation(this.dataDash1);
        },
        benefitForYearsChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getBenefitForYearsChartOptions(this.dataDash1);
        },
        riskAnalysisChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getRiskAnalysisChartOptions(this.dataDash1);
        },
    },
    methods: {
        ...mapActions("dashboard", ["findDataProducts"]),
        ...mapMutations("dashboard", ["resetProductsDashAffected"]),

        handlePriorityPageChange(newPage) {
            this.priorityCurrentPage = newPage;
        },
        async handleChartInfo({ key, title }) {
            this.$set(this.isLoadingChartInfo, key, true);
            this.modalTitle = title;
            this.resetProductsDashAffected();

            try {
                const filters = {
                    ...this.dashboardFilters,
                    affectation: key,
                };
                await this.findDataProducts(filters);
                this.selectedProducts = this.productsDashAffected;
                this.$bvModal.show('products-modal');
            } catch (error) {
                console.error('Error al cargar los productos:', error);
            }
            finally {
                this.$set(this.isLoadingChartInfo, key, false);
            }
        }
    }
};
</script>

<style scoped>
.dashboard {
    background-color: #00000000;
    min-height: 100vh;
}

.secondary-chart {
    margin-top: 21px;
}

.main-title {
    position: relative;
    margin-bottom: 0;
    font-size: 2.2rem;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

.right-column {
    height: 80vh;
    display: flex;
    flex-direction: column;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding-right: 1rem;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.scrollable-content::-webkit-scrollbar {
    display: none;
}

.h-100 {
    height: 100%;
}

.equal-height {
    display: flex;
    flex-wrap: wrap;
}

.equal-height>[class*='col-'] {
    display: flex;
    flex-direction: column;
}

.tree-section {
    .row {
        min-height: 100%;
    }
}
</style>
